import React from 'react';

type Props = React.SVGProps<SVGSVGElement>;

const InformationIcon: React.FC<React.PropsWithChildren<Props>> = props => (
  <svg viewBox="0 0 20 20" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 1C5.02944 1 1 5.02944 1 10C1 14.9706 5.02944 19 10 19C14.9706 19 19 14.9706 19 10C19 5.02944 14.9706 1 10 1ZM0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10ZM8.5 8.5C8.5 8.22386 8.72386 8 9 8H10C10.2761 8 10.5 8.22386 10.5 8.5V13.5H11.5C11.7761 13.5 12 13.7239 12 14C12 14.2761 11.7761 14.5 11.5 14.5H10H8.5C8.22386 14.5 8 14.2761 8 14C8 13.7239 8.22386 13.5 8.5 13.5H9.5V9H9C8.72386 9 8.5 8.77614 8.5 8.5ZM9.75 6.5C10.1642 6.5 10.5 6.16421 10.5 5.75C10.5 5.33579 10.1642 5 9.75 5C9.33579 5 9 5.33579 9 5.75C9 6.16421 9.33579 6.5 9.75 6.5Z"
      fill="#222529"
    />
  </svg>
);

export default InformationIcon;
